<template lang="pug">

  <div class="small">
    <line-chart :chart-data="datacollection"></line-chart>
  </div>

</template>

<script>
import LineChart from '../../../store/components/LineChart.js'

export default {
  data: () => ({
    datacollection: null,
  }),
  props:{
    data: Object
  },
  
    mounted () {
      this.fillData()
    },

    methods: {
      fillData () {
          this.datacollection = {
            labels: [this.getRandomInt(), this.getRandomInt()],
            datasets: [
              {
                label: 'Data One',
                backgroundColor: '#982314',
                data: [this.getRandomInt(), this.getRandomInt()]
              }, {
                label: 'Data One',
                backgroundColor: '#f87979',
                data: [this.getRandomInt(), this.getRandomInt()]
              }
            ]
          }
        },
        getRandomInt () {
          return Math.floor(Math.random() * (50 - 5 + 1)) + 5
        }
    },
    components: {
      LineChart
    },
  
  }
</script>
<style>
  .small {
    max-width: 600px;
    margin:  150px auto;
  }
</style>